import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import DeprecatedOldReactAdapterComponentContainer from "legacy/dangerous/DeprecatedOldReactAdapterComponentContainer"
import { badgeForReservationStatus, humanize } from "legacy/helpers.es6"
import RefundModal from "legacy/manage/cancel/RefundModal"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class ReservationStatusHeader extends ApplicationComponent {
  constructor(args) {
    super(args)
    const hasMeters = !!(
      this.props.currentAssignmentMeters &&
      this.props.currentAssignmentMeters.length > 0
    )
    this.state = {
      checkedInAt: this.props.checkedInAt,
      checkedOutAt: this.props.checkedOutAt,
      displayStatus: this.props.displayStatus,
      status: this.props.status,
      activityLog: this.props.activityLog,
      showModal: false,
      declining: false,
      modalStep: 1,
      showCancelMbmContractModal: false,
      hasMeters,
      currentAssignmentMeter:
        hasMeters && this.props.currentAssignmentMeters.length === 1
          ? this.props.currentAssignmentMeters[0]
          : null,
    }
    this.handleCheckInCheckOut = this.handleCheckInCheckOut.bind(this)
    this.openConfirmCheckInOutModal = this.openConfirmCheckInOutModal.bind(this)
    this.closeConfirmCheckInOutModal =
      this.closeConfirmCheckInOutModal.bind(this)
    this.handleTakeMeteredElectricReading =
      this.handleTakeMeteredElectricReading.bind(this)
    this.toggleCancelMbmContractModal =
      this.toggleCancelMbmContractModal.bind(this)
  }

  trackEvent(eventName) {
    const experienceName = this.props.reservationPage
      ? "reservation_detail"
      : "assignments"
    const experienceProps = {
      reservation_id: this.props.encodedId,
      marina_id: this.props.marina.mcomId,
      marina_name: this.props.marina.name,
      experience_name: experienceName,
    }
    if (this.props.comingFromMapView) {
      Amplitude.trackEvent(
        `${experienceName}:map_view_${eventName}`,
        experienceProps
      )
    } else {
      Amplitude.trackEvent(`${experienceName}:${eventName}`, experienceProps)
    }
  }

  openConfirmCheckInOutModal() {
    this.setState({ showModal: true, modalStep: 1 })
  }

  closeConfirmCheckInOutModal() {
    this.setState({ showModal: false })
  }

  handleCheckInCheckOut() {
    this.setState({ saving: true })
    $.ajax({
      url: !this.state.checkedInAt
        ? this.props.checkInUrl
        : this.props.checkOutUrl,
      type: "POST",
      dataType: "json",
      contentType: "application/json",
      success: (data) => {
        this.trackEvent(!this.state.checkedInAt ? "checked_in" : "checked_out")
        if (this.props.reservationPage) {
          location.reload()
        } else {
          this.props.reloadCurrentGrid(() => {
            this.setState({
              saving: false,
              checkedInAt: data.checkedInAt,
              checkedOutAt: data.checkedOutAt,
              showModal: this.state.hasMeters,
              modalStep: this.state.hasMeters ? 2 : 1,
              displayStatus: data.metaStatus,
              status: data.status,
              activityLog: data.activityLog,
            })
          })
        }
      },
      error: (data) => {
        this.setState({ saving: false })
        const errorMessage =
          data.responseJSON.errors || "Unable to process, please try again"
        alert(errorMessage)
      },
    })
  }

  handleTakeMeteredElectricReading() {
    let meteredElectricUrl = `${DockwaConfig.BASE_URL}/manage/${this.props.marina.slug}/metered_electric`

    if (this.state.currentAssignmentMeter) {
      meteredElectricUrl = `${meteredElectricUrl}#/meters/${this.state.currentAssignmentMeter.id}/metered_electrics/new`
    }

    window.location.href = meteredElectricUrl
  }

  toggleCancelMbmContractModal() {
    this.setState({
      showCancelMbmContractModal: !this.state.showCancelMbmContractModal,
    })
  }

  sortedLogs() {
    return _.sortBy(this.state.activityLog, "timestamp")
  }

  status() {
    return this.state.displayStatus
  }

  disputed() {
    return this.state.displayStatus === "under_dispute"
  }

  isConfirmedStatus() {
    return (
      this.state.status === "confirmed" ||
      this.state.status === "completed" ||
      this.state.status === "checked_in" ||
      this.state.status === "checked_out"
    )
  }

  canCheckInOrOut() {
    return this.status() === "confirmed" || this.status() === "checked_in"
  }

  containerClass() {
    switch (this.status()) {
      case "pending":
        return "bg-yellow-100 border-yellow-800"
      case "confirmed":
        return "bg-blue-50 border-blue-700"
      case "checked_in":
        return "bg-blue-700 border-blue-800"
      case "waitlisted":
        return "bg-orange-100 border-orange-600"
      case "expired":
      case "declined":
      case "payment_declined":
      case "checked_out":
      case "canceled":
        return "bg-gray-100 border-gray-300"
    }
  }

  titleClass() {
    switch (this.status()) {
      case "pending":
        return "text-yellow-800"
      case "confirmed":
        return "text-blue-700"
      case "checked_in":
        return "text-white"
      case "canceled":
      case "declined":
      case "payment_declined":
        return "text-red-800"
      case "waitlisted":
        return "text-orange-800"
      case "checked_out":
      case "expired":
        return "text-gray-800"
      default:
        return "text-gray-800"
    }
  }

  textClass() {
    switch (this.status()) {
      case "checked_in":
        return "text-white"
      default:
        return "text-gray-800"
    }
  }

  renderConfirmCancelButtons() {
    if (
      this.state.status === "pending" &&
      this.props.transientLike &&
      this.props.editable
    ) {
      return (
        <div className="inline-block space-x-3">
          <button
            type="button"
            className="btn btn-secondary"
            data-toggle="modal"
            data-target="#confirm-reservation"
          >
            Confirm
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            data-toggle="modal"
            data-target="#waitlist-reservation"
          >
            Waitlist
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            data-toggle="modal"
            data-target="#decline-reservation"
          >
            Decline
          </button>
        </div>
      )
    } else if (this.isConfirmedStatus() && this.props.editable) {
      if (this.props.scheduled) {
        if (this.props.isMbm) {
          return (
            <div>
              <DeprecatedOldReactAdapterComponentContainer id="cancel-contract-modal-mbm-button" />
            </div>
          )
        } else {
          return (
            <div className="inline-block">
              <RefundModal
                {...this.props.refundModalProps}
                btnClass="btn-secondary"
              />
            </div>
          )
        }
      } else {
        return (
          <button
            className="btn btn-secondary"
            type="button"
            id="cancel-reservation-btn"
            data-toggle="modal"
            data-target="#cancel-reservation"
          >
            {!this.props.belongsToContract ? "Cancel" : "Cancel Contract"}
          </button>
        )
      }
    }
  }

  renderLocked() {
    if (this.isConfirmedStatus() && !this.props.editable) {
      return (
        <div className="flex">
          <i
            className="icon icon-lock-fa text-muted mr-3"
            style={{ fontSize: "30px" }}
          />
          {this.disputed() && (
            <div className="text-muted" style={{ maxWidth: 300 }}>
              Reservation is locked because of disputed charge.
            </div>
          )}
          {!this.disputed() && (
            <div className="text-muted" style={{ maxWidth: 300 }}>
              {this.props.lockedText}
            </div>
          )}
        </div>
      )
    }
  }

  renderActivityLog() {
    return _.map(this.sortedLogs(), (log) => {
      return (
        <div className="flex justify-between space-x-4" key={log.timestamp}>
          <div className={`badge ${badgeForReservationStatus(log.event)}`}>
            {humanize(log.event)}
          </div>
          <span className="text-gray-800">
            {moment
              .parseZone(log.timestamp, moment.ISO_8601)
              .local()
              .format("LT on L")}
          </span>
        </div>
      )
    })
  }

  renderButtons() {
    if (this.props.reservationPage) {
      return (
        <div className="hidden-print flex flex-grow justify-end space-x-3">
          {this.renderLocked()}
          <DeprecatedOldReactAdapterComponentContainer id="edit-product-sale-button-mbm" />
          {this.canCheckInOrOut() && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.openConfirmCheckInOutModal}
            >
              {this.status() === "confirmed" ? "Check In" : "Check Out"}
            </button>
          )}
          {this.props.waitlistUrl && (
            <a className="btn btn-secondary" href={this.props.waitlistUrl}>
              {this.props.waitlistButtonTitle}
            </a>
          )}
          {this.renderConfirmCancelButtons()}
        </div>
      )
    } else if (this.canCheckInOrOut()) {
      return (
        <LegacyButton
          type="secondary"
          onClick={this.openConfirmCheckInOutModal}
        >
          {this.status() === "confirmed" ? "Check In" : "Check Out"}
        </LegacyButton>
      )
    }
  }

  footerStepDisplay() {
    if (this.state.hasMeters) {
      return (
        <div className="bs-mt-3 float-left">{this.state.modalStep} of 2</div>
      )
    }
  }

  modalTitle() {
    if (this.state.modalStep === 1) {
      return !this.state.checkedInAt ? "Confirm Check In" : "Confirm Check Out"
    } else {
      return !this.state.checkedOutAt
        ? "New electric reading"
        : "Final electric reading"
    }
  }

  modalSaveButtonText() {
    if (this.state.modalStep === 1) {
      return !this.state.checkedInAt ? "Check In" : "Check Out"
    } else {
      return "Yes, take a reading"
    }
  }

  renderModalContent() {
    if (this.state.modalStep === 1) {
      return (
        <div>
          <p>
            This will{" "}
            <strong>Check {!this.state.checkedInAt ? "In" : "Out"}</strong>{" "}
            reservation #{this.props.encodedId} for{" "}
            <strong>{this.props.customerName}</strong> on{" "}
            <strong>{this.props.boatText}</strong>.
          </p>
          <p>
            This action can not be undone, are you sure you wish to continue?
          </p>
        </div>
      )
    } else {
      if (this.state.currentAssignmentMeter) {
        return (
          <p>
            Would you like to take{" "}
            {this.state.checkedOutAt ? "a final" : "an initial"} electric
            reading at meter {this.state.currentAssignmentMeter.name} for this{" "}
            {this.state.checkedOutAt ? "customer" : "reservation"}?
          </p>
        )
      } else {
        return (
          <p>
            Would you like to take{" "}
            {this.state.checkedOutAt ? "a final" : "an initial"} electric
            reading for this reservation?
          </p>
        )
      }
    }
  }

  render() {
    return (
      <div>
        <DeprecatedOldReactAdapterComponentContainer id="signed-contract-dispute-alert-banner" />
        <div
          className={`flex flex-col rounded border ${this.containerClass()} space-y-3 p-5 ${
            this.props.reservationPage
              ? "items-center rounded-b-none lg:flex-row lg:space-y-0"
              : ""
          }`}
        >
          <div>
            <h2 className={`text-2xl font-bold ${this.titleClass()} mb-1 mt-0`}>
              {humanize(this.status())}
            </h2>
            <div
              className={`flex ${
                this.props.reservationPage ? "space-x-10" : "justify-between"
              }`}
            >
              <p className={`mb-0 ${this.textClass()}`}>
                {moment
                  .parseZone(
                    this.sortedLogs()[this.sortedLogs().length - 1].timestamp
                  )
                  .local()
                  .format("LT on L")}
              </p>
              <div
                className={`cursor-pointer ${this.textClass()}`}
                onMouseEnter={() => this.setState({ showHistory: true })}
                onMouseLeave={() => this.setState({ showHistory: false })}
              >
                History
                <i className="icon icon-chevron-down" />
                {this.state.showHistory && (
                  <div
                    className={`card absolute z-10 mt-1 space-y-4 ${
                      this.props.reservationPage ? "-ml-40 lg:ml-0" : "-ml-56"
                    }`}
                  >
                    {this.renderActivityLog()}
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.renderButtons()}
          <Modal
            isOpen={this.state.showModal}
            onClose={this.closeConfirmCheckInOutModal}
            size="small"
          >
            <Modal.Header title={this.modalTitle()} />
            <Modal.Body>{this.renderModalContent()}</Modal.Body>
            <Modal.Footer>
              <div className="flex w-full items-center justify-end">
                {this.footerStepDisplay()}
                <div className="flex gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={this.closeConfirmCheckInOutModal}
                  >
                    {this.state.modalStep === 1 ? "Cancel" : "No"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={
                      this.state.modalStep === 1
                        ? this.handleCheckInCheckOut
                        : this.handleTakeMeteredElectricReading
                    }
                    disabled={this.state.saving}
                  >
                    {this.state.saving ? (
                      <>
                        <span
                          className="icon icon-spin icon-spinner mr-2"
                          aria-label="loading indicator"
                          aria-hidden="true"
                        />
                        {this.modalSaveButtonText()}
                      </>
                    ) : (
                      this.modalSaveButtonText()
                    )}
                  </button>
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    )
  }
}

ReservationStatusHeader.propTypes = {
  activityLog: PropTypes.array.isRequired,
  belongsToContract: PropTypes.bool,
  boatText: PropTypes.string,
  checkedInAt: PropTypes.string,
  checkedOutAt: PropTypes.string,
  checkInUrl: PropTypes.string,
  checkOutUrl: PropTypes.string,
  comingFromMapView: PropTypes.bool,
  currentAssignmentMeters: PropTypes.array,
  customerName: PropTypes.string,
  currentPrice: PropTypes.number,
  displayStatus: PropTypes.string,
  editable: PropTypes.bool,
  encodedId: PropTypes.string,
  isMbm: PropTypes.bool,
  marina: PropTypes.object.isRequired,
  refundModalProps: PropTypes.object,
  reservationPage: PropTypes.bool,
  scheduled: PropTypes.bool,
  showRefundModal: PropTypes.bool,
  status: PropTypes.string.isRequired,
  transientLike: PropTypes.bool,
  boaterCancel: PropTypes.bool,
}

export default ReservationStatusHeader
